export default __webpack_public_path__ + "media/images/images_v2/tabs-over-17fd4fb697f83753251736ef7c054643.png";